
















// @ts-nocheck
import { panoramicQueryServer, regionServe, yunnanDataViewServer } from '@/api/installServer';

let map: any;
const zoom = 14;
const handler: any = [];
let viewer: any;
let zyBlackDataSource: any;
import { Component, Vue } from 'vue-property-decorator';
import Video from '@/views/dataView/ziYangDataViewBlack/unit/Video';
import AreaMapInfo from '@/views/dataView/ziYangDataViewBlack/unit/map/areaMapInfo.vue';

@Component({
  components: { Video, AreaMapInfo },
})
export default class ViewMap extends Vue {
  entData: any = [];
  mapType: any = 1;
  changeSwitch: any = true;
  mapLoad: any = true;
  mounted() {
    this.changeSwitch = window.localStorage.getItem('changeMap');
    document.addEventListener('contextmenu', event => event.preventDefault());
    this.getData();
  }
  getData() {
    yunnanDataViewServer
      .getCompanyAll()
      .then((res: any) => {
        if (res.code === '200') {
          this.entData = res.data;
          this.show3DMap();
        } else {
          this.$message.warning(res.msg);
        }
      })
      .catch(() => {});
  }

  async show3DMap() {
    this.haveShow = true;
    const token = '4c3a4b8cec3d4af47a12cdd192ce35cb';
    // 服务域名
    const tdtUrl = 'https://t{s}.tianditu.gov.cn/';
    // 服务负载子域
    const subdomains = ['0', '1', '2', '3', '4', '5', '6', '7'];

    // cesium 初始化
    viewer = new Cesium.Map('mapDiv3D', {
      shouldAnimate: true,
      selectionIndicator: true,
      infoBox: false,
      selectionIndicator: false, // 关闭选中绿框
    });

    // 叠加影像服务
    const imgMap = new Cesium.UrlTemplateImageryProvider({
      url: tdtUrl + 'DataServer?T=vec_w&x={x}&y={y}&l={z}&tk=' + token,
      subdomains: subdomains,
      tilingScheme: new Cesium.WebMercatorTilingScheme(),
      maximumLevel: 18,
    });
    viewer.imageryLayers.addImageryProvider(imgMap);

    // 叠加标注服务
    const imgMapName = new Cesium.UrlTemplateImageryProvider({
      url: tdtUrl + 'DataServer?T=cva_w&x={x}&y={y}&l={z}&tk=' + token,
      subdomains: subdomains,
      tilingScheme: new Cesium.WebMercatorTilingScheme(),
      maximumLevel: 18,
    });
    const imgMapNameViewer = viewer.imageryLayers.addImageryProvider(imgMapName);

    //新建dataSources
    zyBlackDataSource = new Cesium.CustomDataSource('inverseShade');
    viewer.dataSources.add(zyBlackDataSource);
    const obj: any = {
      // destination: Cesium.Cartesian3.fromDegrees(104.627147, 30.129235, 10000),
      destination: Cesium.Cartesian3.fromDegrees(104.14872, 30.68284, 30000),
      orientation: {
        heading: Cesium.Math.toRadians(360),
        pitch: Cesium.Math.toRadians(-90),
        roll: Cesium.Math.toRadians(0),
      },
      complete: function callback() {
        // 定位完成之后的回调函数
      },
    };

    // 将三维球定位到中国
    viewer.camera.flyTo(obj);

    // 叠加三维地名服务
    const wtfs = new Cesium.GeoWTFS({
      viewer,
      subdomains: subdomains,
      metadata: {
        boundBox: {
          minX: -180,
          minY: -90,
          maxX: 180,
          maxY: 90,
        },
        minLevel: 1,
        maxLevel: 20,
      },
      aotuCollide: true, //是否开启避让
      collisionPadding: [5, 10, 8, 5], //开启避让时，标注碰撞增加内边距，上、右、下、左
      serverFirstStyle: true, //服务端样式优先
      labelGraphics: {
        font: '28px sans-serif',
        fontSize: 28,
        fillColor: Cesium.Color.WHITE,
        scale: 0.5,
        outlineColor: Cesium.Color.BLACK,
        outlineWidth: 5,
        style: Cesium.LabelStyle.FILL_AND_OUTLINE,
        showBackground: false,
        backgroundColor: Cesium.Color.RED,
        backgroundPadding: new Cesium.Cartesian2(10, 10),
        horizontalOrigin: Cesium.HorizontalOrigin.MIDDLE,
        verticalOrigin: Cesium.VerticalOrigin.TOP,
        eyeOffset: Cesium.Cartesian3.ZERO,
        pixelOffset: new Cesium.Cartesian2(0, 8),
      },
      billboardGraphics: {
        horizontalOrigin: Cesium.HorizontalOrigin.CENTER,
        verticalOrigin: Cesium.VerticalOrigin.CENTER,
        eyeOffset: Cesium.Cartesian3.ZERO,
        pixelOffset: Cesium.Cartesian2.ZERO,
        alignedAxis: Cesium.Cartesian3.ZERO,
        color: Cesium.Color.WHITE,
        rotation: 0,
        scale: 1,
        width: 18,
        height: 18,
      },
    });
    const userInfo: any = JSON.parse((localStorage as any).getItem('userInfo'));
    if (userInfo.deptType === '5' || userInfo.deptType === '6') {
      //  企业
      panoramicQueryServer.getSinglePerformanceData({ id: userInfo.deptId }).then((res: any) => {
        if (res.code === '200' && res.data) {
          this.$emit('entChange', {
            companyName: res.data.companyName,
            id: res.data.id,
            areaId: res.data.area,
          });
          this.setArea(res.data.area, res.data.lat, res.data.lng);
        }
      });
    } else {
      this.entData.forEach((item: any) => {
        if (item.lat && item.lng) {
          viewer.entities.add({
            position: Cesium.Cartesian3.fromDegrees(Number(item.lng), Number(item.lat), 1),
            type: 'ent',
            id: item.id,
            areaId: item.area,
            companyName: item.companyName,
            lng: item.lng,
            lat: item.lat,
            billboard: {
              image: 'map/img/icon/icon_zy/qyG.png',
              // image: typeImgObjEnt[item.securityRiskGrade],
              pixelOffset: new Cesium.Cartesian2(0, 13),
              verticalOrigin: Cesium.VerticalOrigin.BOTTOM,
              // scale: 0.8,
              scale: 0.2,
            },
            label: {
              show: true,
              text: item.companyName,
              // font: 'normal 32px Helvetica',
              // color: Cesium.Color.fromCssColorString('#fff'),
              // backgroundColor: new Cesium.Color.fromCssColorString('rgba(0,0,0,0.7)'),
              // showBackground: true,
              // scale: 0.4,
              // // distanceDisplayCondition: new Cesium.DistanceDisplayCondition(0, 500),
              // // scaleByDistance: new Cesium.NearFarScalar(100, 2, 500, 0.0),
              // // horizontalOrigin: Cesium.HorizontalOrigin.LEFT,
              // // verticalOrigin: Cesium.VerticalOrigin.TOP,
              // pixelOffset: new Cesium.Cartesian2(0, 20),
              font: '28px sans-serif',
              fontSize: 22,
              fillColor: Cesium.Color.WHITE,
              scale: 0.5,
              outlineColor: Cesium.Color.BLACK,
              outlineWidth: 5,
              style: Cesium.LabelStyle.FILL_AND_OUTLINE,
              showBackground: false,
              backgroundColor: Cesium.Color.RED,
              backgroundPadding: new Cesium.Cartesian2(10, 10),
              horizontalOrigin: Cesium.HorizontalOrigin.MIDDLE,
              verticalOrigin: Cesium.VerticalOrigin.TOP,
              eyeOffset: Cesium.Cartesian3.ZERO,
              pixelOffset: new Cesium.Cartesian2(0, 12),
            },
          });
        }
      });
      regionServe
        .getRegionDataById(userInfo.areaId)
        .then((res: any) => {
          if (res.code === '200') {
            console.log('区域------------------：', res.data);
            if (res.data && res.data.mapPoint && res.data.mapPoint.pointArr && res.data.mapPoint.pointArr.length) {
              let x1: any = null; // 坐标最大最小值
              let x2: any = null;
              let y1: any = null;
              let y2: any = null;
              const points: any = [];
              res.data.mapPoint.pointArr[0].forEach((itemC: any) => {
                if (!x1 || itemC.lng < x1) {
                  x1 = itemC.lng;
                }
                if (!x2 || itemC.lng > x2) {
                  x2 = itemC.lng;
                }

                if (!y1 || itemC.lat < y1) {
                  y1 = itemC.lat;
                }
                if (!y2 || itemC.lat > y2) {
                  y2 = itemC.lat;
                }
                points.push(itemC.lng);
                points.push(itemC.lat);
              });
              points.push(res.data.mapPoint.pointArr[0][0].lng);
              points.push(res.data.mapPoint.pointArr[0][0].lat);
              const areaPoint = [(Number(x1) + Number(x2)) / 2, (Number(y1) + Number(y2)) / 2];
              const obj: any = {
                destination: Cesium.Cartesian3.fromDegrees(areaPoint[0], areaPoint[1], 3000),
                orientation: {
                  // heading: Cesium.Math.toRadians(360.4202942851978), // 偏航角，默认方向为正北（0°），正角度为向东旋转，即左右摇头
                  // pitch: Cesium.Math.toRadians(-40), // 俯仰角，默认角度为-90°，即朝向地面，0°为平视，正角度为仰视，负角度为俯视，即抬头低头
                  // roll: Cesium.Math.toRadians(0), // 翻转角，默认角度为0°，正角度向右旋转，负角度向左旋转，即左右歪头
                  heading: Cesium.Math.toRadians(360),
                  pitch: Cesium.Math.toRadians(-90),
                  roll: Cesium.Math.toRadians(0),
                },
                complete: function callback() {
                  // 定位完成之后的回调函数
                },
              };

              // 三维球定位
              viewer.camera.flyTo(obj);

              viewer.entities.add({
                polyline: {
                  positions: Cesium.Cartesian3.fromDegreesArray(points),
                  width: 15.0,
                  material: new Cesium.PolylineGlowMaterialProperty({
                    color: Cesium.Color.fromCssColorString('#3276ff').withAlpha(1),
                    glowPower: 0.25,
                  }),
                },
              });
            }
          } else {
            this.$message.warning(res.msg);
          }
        })
        .catch(() => {});
    }

    const handler = new Cesium.ScreenSpaceEventHandler(viewer.scene.canvas); // RIGHT_CLICK
    handler.setInputAction((e: any) => {
      const pick = viewer.scene.pick(e.position);
      if (pick && pick.id && pick.id._type === 'ent_point') {
        const data: any = {
          id: pick.id._id,
          name: pick.id._name,
        };
        this.$router.push({ name: 'BusinessManagement', params: data });
      }
      if (pick && pick.id && pick.id._type === 'area') {
        const form: any = {
          id: pick.id._id,
        };
        (this.$refs.AreaMapInfo as any).showDialog(form);
      }
      if (pick && pick.id && pick.id._type === 'ent') {
        this.$emit('entChange', {
          companyName: pick.id._companyName,
          id: pick.id._id,
          areaId: pick.id._areaId,
        });
        this.setArea(pick.id._areaId, pick.id._lat, pick.id._lng);
      }

      if (pick && pick.id && pick.id._type === 'video') {
        // 覆盖物类型为video(视频)
        if (this.choseVideoMark) {
          this.videoArr.findIndex((itemC: any) => {
            return itemC.code === pick.id._code;
          }) === -1 &&
            this.videoArr.push({
              code: pick.id._code,
              name: pick.id._name,
              num: pick.id.num,
            });
        } else {
          const videoArr: any = [];
          videoArr.push({
            code: pick.id._code,
            name: pick.id._name,
            num: pick.id.num,
          });
          (this.$refs.Video as Video).showDialog(videoArr);
        }
      }
    }, Cesium.ScreenSpaceEventType.LEFT_CLICK);

    setTimeout(() => {
      this.mapLoad = false;
    }, 1000);
  }
  setArea(id: any, lat: any, lng: any) {
    viewer.entities.removeAll();
    this.mapLoad = true;
    const obj: any = {
      destination: Cesium.Cartesian3.fromDegrees(lng + 0.002, lat - 0.008, 700),
      orientation: {
        heading: Cesium.Math.toRadians(360.4202942851978), // 偏航角，默认方向为正北（0°），正角度为向东旋转，即左右摇头
        pitch: Cesium.Math.toRadians(-40), // 俯仰角，默认角度为-90°，即朝向地面，0°为平视，正角度为仰视，负角度为俯视，即抬头低头
        roll: Cesium.Math.toRadians(0), // 翻转角，默认角度为0°，正角度向右旋转，负角度向左旋转，即左右歪头
      },
      complete: function callback() {
        // 定位完成之后的回调函数
      },
    };

    // 三维球定位
    viewer.camera.flyTo(obj);

    regionServe
      .getRegionDataDetailsById(id)
      .then((res: any) => {
        if (res.code === '200') {
          // viewer.entities.removeAll();
          // viewer.entities.remove('areaId');

          res.data.forEach((area: any) => {
            let outlineMark: any = false; // 是否有边框标记
            let buildingHeight: any = 0;
            let withAlpha: any = 0.6; // 盒子透明度

            // 厂区周围添加黑色遮盖
            if (area.areaType === '厂区') {
              const point: any = [];
              area.mapPoint.pointArr[0].forEach((pointCq: any) => {
                point.push(pointCq.lng);
                point.push(pointCq.lat);
              });
              point.push(area.mapPoint.pointArr[0][0].lng);
              point.push(area.mapPoint.pointArr[0][0].lat);
              const hole = Cesium.Cartesian3.fromDegreesArray(point);

              zyBlackDataSource.entities.add({
                polygon: {
                  // 获取指定属性（positions，holes（图形内需要挖空的区域））
                  hierarchy: {
                    //左下左上右上右下
                    // 对应经纬度[0,60],[0,-60],[180,-60],[180,60],[0,60]
                    positions: [
                      {
                        x: 3197104.586923899,
                        y: 0.5580000157243585,
                        z: 5500477.1339386385,
                      },
                      {
                        x: 3197104.586923899,
                        y: 0.5580000157243585,
                        z: -5500477.1339386385,
                      },
                      {
                        x: -3197104.5869239476,
                        y: 3.915323898915733,
                        z: -5500477.1339386385,
                      },
                      {
                        x: -3197104.5869239476,
                        y: 3.915323898915733,
                        z: 5500477.1339386385,
                      },
                      {
                        x: 3197104.586923899,
                        y: 0.5580000157243585,
                        z: 5500477.1339386385,
                      },
                    ],
                    holes: [{ positions: hole }],
                  },
                  // 填充的颜色，withAlpha透明度
                  material: Cesium.Color.WHITE.withAlpha(1),
                  // 是否被提供的材质填充
                  fill: true,
                  // 是否显示
                  show: true,
                  // 顺序,仅当`clampToGround`为true并且支持地形上的折线时才有效。
                  zIndex: 10,
                },
              });
              zyBlackDataSource.entities.add({
                polyline: {
                  positions: hole,
                  width: 8,
                  material: new Cesium.Color.fromCssColorString('rgba(29,79,222,0.8)'),
                  clampToGround: true,
                },
              });
            }

            if (area.areaType === '道路') {
              buildingHeight = 0;
              outlineMark = true;
              withAlpha = 0;
            } else {
              buildingHeight = area.buildingHeight > 0 ? area.buildingHeight : 0;
            }
            if (area.baseRiskLevel === 'C') {
              withAlpha = 0.4;
            }
            if (buildingHeight >= 100) {
              buildingHeight = 0;
            }
            if (buildingHeight === 0) {
              withAlpha = 0;
            }
            const colorArr: any = {
              A: Cesium.Color.RED.withAlpha(withAlpha), // Cesium.Color.RAD #f14343
              B: Cesium.Color.ORANGE.withAlpha(withAlpha), // Cesium.Color.ORANGE #f18d40
              C: Cesium.Color.YELLOW.withAlpha(withAlpha), // Cesium.Color.YELLOW #fcdd41
              // D: Cesium.Color.BLUE.withAlpha(withAlpha), // Cesium.Color.BLUE #3276ff
              D: Cesium.Color.fromCssColorString('#3276ff').withAlpha(withAlpha),
            }; // 盒子颜色
            const colorArrOutLine: any = {
              A: Cesium.Color.RED.withAlpha(1), // Cesium.Color.RAD #f14343
              B: Cesium.Color.ORANGE.withAlpha(1), // Cesium.Color.ORANGE #f18d40
              C: Cesium.Color.YELLOW.withAlpha(1), // Cesium.Color.YELLOW #fcdd41
              // D: Cesium.Color.BLUE.withAlpha(1), // Cesium.Color.BLUE #3276ff
              D: Cesium.Color.fromCssColorString('#3276ff').withAlpha(1),
            }; // 边框颜色
            let color = Cesium.Color.fromCssColorString('#FFFFFF').withAlpha(withAlpha);
            let colorOutLine = Cesium.Color.fromCssColorString('#FFFFFF').withAlpha(1);
            if (area.baseRiskLevel) {
              color = colorArr[area.baseRiskLevel];
              colorOutLine = colorArrOutLine[area.baseRiskLevel];
            }

            if (area.mapPoint) {
              area.mapPoint.pointArr.forEach((item: any, index: any) => {
                const points: any = [];

                let x1: any = null; // 坐标最大最小值
                let x2: any = null;
                let y1: any = null;
                let y2: any = null;

                item.forEach((itemC: any) => {
                  points.push(itemC.lng);
                  points.push(itemC.lat);
                  if (!x1 || itemC.lng < x1) {
                    x1 = itemC.lng;
                  }
                  if (!x2 || itemC.lng > x2) {
                    x2 = itemC.lng;
                  }

                  if (!y1 || itemC.lat < y1) {
                    y1 = itemC.lat;
                  }
                  if (!y2 || itemC.lat > y2) {
                    y2 = itemC.lat;
                  }
                });
                const areaPoint = [(x1 + x2) / 2, (y1 + y2) / 2];

                if (area.mapPoint) {
                  item.error = 0;
                  const imgSize: any = [0.8, 0.8];
                  const imgOffset: any = [13, 26];
                  const z1 = -area.buildingHeight - 20;
                  const z2 = -area.buildingHeight - 1;

                  viewer.entities.add({
                    dataJson: JSON.stringify(area),
                    type: 'area-label',
                    position: Cesium.Cartesian3.fromDegrees(areaPoint[0], areaPoint[1], 1),
                    id: area.id + 'label' + index,
                    areaId: area.id,
                    billboard: {
                      // image: `map/img/icon/warning-b.png`,
                      eyeOffset: buildingHeight > 0 ? new Cesium.Cartesian3(0, 0, z1) : null,
                      // pixelOffset: new Cesium.Cartesian2(0, imgOffset[item.error]),
                      // verticalOrigin: Cesium.VerticalOrigin.BOTTOM,
                      scale: 0.6,
                    },
                    label: {
                      show: true,
                      text: area.name,
                      // font: 'normal 32px Helvetica',
                      // color: Cesium.Color.fromCssColorString('#fff'),
                      // backgroundColor: new Cesium.Color.fromCssColorString('rgba(0,0,0,0.7)'),
                      // showBackground: true,
                      // scale: 0.4,
                      // // distanceDisplayCondition: new Cesium.DistanceDisplayCondition(0, 500),
                      // // scaleByDistance: new Cesium.NearFarScalar(100, 2, 500, 0.0),
                      // // horizontalOrigin: Cesium.HorizontalOrigin.LEFT,
                      // // verticalOrigin: Cesium.VerticalOrigin.TOP,
                      // pixelOffset: new Cesium.Cartesian2(0, 20),
                      font: '28px sans-serif',
                      fontSize: 22,
                      fillColor: Cesium.Color.BLACK,
                      scale: 0.5,
                      outlineColor: Cesium.Color.WHITE,
                      outlineWidth: 5,
                      style: Cesium.LabelStyle.FILL_AND_OUTLINE,
                      showBackground: false,
                      backgroundColor: Cesium.Color.RED,
                      backgroundPadding: new Cesium.Cartesian2(10, 10),
                      horizontalOrigin: Cesium.HorizontalOrigin.MIDDLE,
                      verticalOrigin: Cesium.VerticalOrigin.TOP,
                      eyeOffset: buildingHeight > 0 ? new Cesium.Cartesian3(0, 0, z1) : null,
                      pixelOffset: new Cesium.Cartesian2(0, 0),
                    },
                  });

                  // const datasource: any = viewer;
                  // const dataWarning: any = {
                  //   id: area.id,
                  //   name: '',
                  //   // eyeOffset: new Cesium.Cartesian3(0, 0, z2),
                  //   coordinate: [areaPoint[0], areaPoint[1], 1],
                  // };
                  // // datasource.entities.removeAll();
                  // let x = 1;
                  // let flog = true;
                  // datasource.entities.add({
                  //   position: Cesium.Cartesian3.fromDegrees(dataWarning.coordinate[0], dataWarning.coordinate[1], dataWarning.coordinate[2]),
                  //   id: area.id + index,
                  //   //通过动态改变缩放大小实现闪烁动画1
                  //   billboard: {
                  //     image: `map/img/icon/warning-y.png`,
                  //     eyeOffset: buildingHeight > 0 ? new Cesium.Cartesian3(0, 0, z2) : null,
                  //     // pixelOffset: new Cesium.Cartesian2(0, -50),
                  //     scale: new Cesium.CallbackProperty(function() {
                  //       if (flog) {
                  //         x = x - 0.02;
                  //         if (x <= 0.2) {
                  //           flog = false;
                  //         }
                  //       } else {
                  //         x = x + 0.02;
                  //         if (x >= 0.6) {
                  //           flog = true;
                  //         }
                  //       }
                  //       return x;
                  //     }, false),
                  //   },
                  //   properties: new Cesium.PropertyBag({
                  //     type: 'warning',
                  //     details: dataWarning,
                  //   }),
                  // });
                }

                // let y = 1;
                // let flogY = true;
                viewer.entities.add({
                  dataJson: JSON.stringify(area),
                  type: 'area',
                  id: area.id + 'S' + index,
                  polygon: {
                    hierarchy: Cesium.Cartesian3.fromDegreesArray(points),
                    // heightReference: Cesium.HeightReference.CLAMP_TO_GROUND,
                    extrudedHeight: buildingHeight,
                    material: color,
                    // material: new Cesium.ColorMaterialProperty(
                    //   new Cesium.CallbackProperty(function() {
                    //     if (flogY) {
                    //       y = y - 0.01;
                    //       if (y <= 0.2) {
                    //         flogY = false;
                    //       }
                    //     } else {
                    //       y = y + 0.01;
                    //       if (y >= 0.8) {
                    //         flogY = true;
                    //       }
                    //     }
                    //     return Cesium.Color.RED.withAlpha(x);
                    //   }, false),
                    // ),
                    outline: true,
                    // outline: outlineMark,
                    outlineColor: colorOutLine,
                    // outlineColor: Cesium.Color.RED,
                  },
                });
              });
            }
          });
          setTimeout(() => {
            this.mapLoad = false;
          }, 1000);
        } else {
          this.$message.warning(res.msg);
        }
      })
      .catch(() => {});

    const videoArr: any = [
      {
        id: '5d3a893ce9f348be9eaf166844c4fc5a',
        videoName: '1',
        resourceName: null,
        aliasVideoName: null,
        videoIndexCode: 'K74876097',
        brand: null,
        areaId: '01dcabf5cd4140d187cc3863ec4c0cb3',
        areaName: '百威（四川）啤酒有限公司',
        longitude: '104.6452',
        latitude: '30.09289',
        isShowMap: true,
      },
      {
        id: '60e280e9cc8d11ed86b602420a000008',
        videoName: '8',
        resourceName: null,
        aliasVideoName: '',
        videoIndexCode: 'K13889438',
        brand: '',
        areaId: '4c17039ff868083da99ec38bebb8bf08',
        areaName: '资阳市润丰化工有限公司',
        longitude: '104.64598',
        latitude: '30.07004',
        isShowMap: true,
      },
    ];
    // videoArr.forEach((item: any, index: any) => {
    //   if (item.latitude > 0 && item.longitude > 0) {
    //     console.log(item.longitude,item.latitude);
    //     viewer.entities.add({
    //       id: '3DVideo-' + index,
    //       position: Cesium.Cartesian3.fromDegrees(item.longitude, item.latitude, 1),
    //       type: 'video',
    //       code: item.videoIndexCode,
    //       name: item.videoName + ' - ' + item.areaName,
    //       num: item.videoName,
    //       billboard: {
    //         image: 'map/img/icon/icon_sxt_1.png',
    //         pixelOffset: new Cesium.Cartesian2(0, 13),
    //         verticalOrigin: Cesium.VerticalOrigin.BOTTOM,
    //         scale: 0.8,
    //       },
    //     });
    //   }
    // });

    yunnanDataViewServer
      .getMapCamera()
      .then((res: any) => {
        if (res.code === '200') {
          // console.log(res.data,'res.data');
          res.data.forEach((item: any, index: any) => {
            if (item.latitude > 0 && item.longitude > 0) {
              viewer.entities.add({
                id: '3DVideo-' + index,
                position: Cesium.Cartesian3.fromDegrees(item.longitude, item.latitude, 1),
                type: 'video',
                code: item.videoIndexCode,
                name: item.videoName + ' - ' + item.areaName,
                num: item.videoName,
                billboard: {
                  image: 'map/img/icon/icon_sxt_1.png',
                  pixelOffset: new Cesium.Cartesian2(0, 13),
                  verticalOrigin: Cesium.VerticalOrigin.BOTTOM,
                  scale: 0.8,
                },
              });
            }
          });
        } else {
          this.$message.warning(res.msg);
        }
      })
      .catch(() => {});

    // const videoRes: any = await yunnanDataViewServer.getMapCamera();
    // this.videoNum = videoRes.data.length;
    // // console.log(videoRes);
    // videoRes.data.forEach((item: any, index: any) => {
    //   if (item.latitude > 0 && item.longitude > 0) {
    //     viewer.entities.add({
    //       id: '3DVideo-' + index,
    //       position: Cesium.Cartesian3.fromDegrees(item.longitude, item.latitude, 1),
    //       type: 'video',
    //       code: item.videoIndexCode,
    //       name: item.resourceName + ' - ' + item.areaName,
    //       billboard: {
    //         image: 'map/img/icon/icon_sxt_1.png',
    //         pixelOffset: new Cesium.Cartesian2(0, 13),
    //         verticalOrigin: Cesium.VerticalOrigin.BOTTOM,
    //         scale: 0.8,
    //       },
    //     });
    //   }
    // });

    // const specialEquRes: any = await yunnanDataViewServer.getDeviceInfoList();
    // const specialEquRes: any = [
    //   {
    //     longitude: 104.64641,
    //     latitude: 30.07152,
    //     deviceId: '0000001',
    //   },
    // ];
    // this.specialEquMarkData = specialEquRes;
    // const typeImgObjSpecialEqu: any = {
    //   iconEqu: ['map/img/icon/icon_equ.png'],
    // };
    //
    // specialEquRes.forEach((item: any, index: any) => {
    //   if (item.latitude > 0 && item.longitude > 0) {
    //     viewer.entities.add({
    //       position: Cesium.Cartesian3.fromDegrees(Number(item.longitude), Number(item.latitude), 1),
    //       type: 'special',
    //       id: item.deviceId,
    //       // id: '3DSpecialEqu-' + index,
    //       deviceId: item.deviceId,
    //       billboard: {
    //         image: typeImgObjSpecialEqu.iconEqu[0],
    //         pixelOffset: new Cesium.Cartesian2(0, 13),
    //         verticalOrigin: Cesium.VerticalOrigin.BOTTOM,
    //         scale: 0.8,
    //       },
    //     });
    //   }
    // });
  }

  created() {
    window.close3DPopup = this.close3DPopup;
  }
  close3DPopup(id: any) {
    const box = document.getElementById('3DPopupBox-' + id);
    box.remove();
    viewer.clock.onTick.removeEventListener(this.eventListener);
  }

  private pointData: any = [];
  setEntPoint(data: any) {
    this.pointData.forEach((item: any) => {
      const getByIdBox = viewer.entities.getById(item.id);
      viewer.entities.remove(getByIdBox);
    });
    this.pointData = data;
    data.forEach((item: any) => {
      viewer.entities.add({
        position: Cesium.Cartesian3.fromDegrees(item.lng, item.lat, 0),
        type: 'ent_point',
        id: item.id,
        name: item.companyName,
        billboard: {
          image: 'map/icon/ent-icon.png',
          scale: 1,
        },
        cursor: 'pointer',
      });
    });
  }
}
